<template>
  <div class="btnsWrapper">
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.btnsWrapper {
  margin-top: 20px;
  :deep() {
    .btn:nth-child(2) {
      margin-right: 10px;
    }
  }
}
</style>
